import counterUp from 'counterup2';
import waypoint from '../libs/waypoint/noframework.waypoints.min';
document.querySelectorAll('.stats__title').forEach(function (el) {
  new Waypoint({
    element: el,
    handler: function handler() {
      counterUp(el, {
        duration: 3000,
        delay: 16
      });
      this.destroy();
    },
    offset: '98%'
  });
});